@if (loading()) {
<div class="spinner-container">
  <mat-spinner [color]="color()" [diameter]="diameter()"></mat-spinner>
</div>
} @else {
<ng-content></ng-content>
}
